<main class="d-padding large-padding">
    <h2>User Profile</h2>
    <div class="user-profie-container">
        <div class="user-profile-details">
            <div class="form-list">
                <h3>{{userDetails.first_name}} {{userDetails.last_name}}<span>{{userDetails.username}}</span></h3>
                <div class="user-profile">
                    <div class="user-profile-pic">
                        <!-- <div class="form-group" >
                            <button class="btn btn-upload" (click)="open(content)">Upload profile picture</button>
                        </div> -->
                        <div class="user-prev" (click)="open(content)">
                            <span>Change profile picture</span>
                            <figure>
                                <img [src]="croppedImage" alt="">
                            </figure>
                            <!-- <a href="javascript:void(0)" (click)="clearAvatar()"> -->
                            <i class="icon icon-close"></i>
                            <!-- </a> -->

                        </div>
                    </div>
                    <div class="row">
                        <form [formGroup]="nameForm">
                            <div class="col-sm-6 name">
                                <div class="form-group">
                                    <label>First Name</label>
                                    <input #firstName id="firstName" class="c-form-control firstName" formControlName="firstName" placeholder="First Name" value="{{userDetails.first_name}}" (keyup)="firstNameCheck(); firstNameChanged = true"
                                        autocomplete="off" />
                                    <!-- <input class="form-control va-title" placeholder="Ask CIRA" [(ngModel)]="user.name" />   
                                                      -->


                                    <span class="error" *ngIf="!firstNameValid"> {{firstNameErrorMsg}}</span>
                                    <!-- <span class="error" *ngIf="firstName.value.length > 40" >  {{firstNameErrorMsg}}</span> -->
                                </div>
                            </div>
                            <div class="col-sm-6 name">
                                <div class="form-group">
                                    <label>Last Name</label>
                                    <input #lastName class="c-form-control lastName" placeholder="Last Name" formControlName="lastName" value="{{userDetails.last_name}}" maxlength="41" (keyup)="lastNameCheck(); lastNameChanged = true" autocomplete="off" />
                                    <!-- <input class="form-control va-title" placeholder="Ask CIRA" [(ngModel)]="user.name" />        
                                                 -->
                                    <i #nameInfo="ngbTooltip" class="icon-information" placement="right" ngbTooltip=" First name should have minimum 2 letters and should be less than 40 letters.  &#013;      Last name should be less than 40 letters"></i>
                                    <span class="error" *ngIf="!lastNameValid"> {{lastNameErrorMsg}}</span>
                                </div>
                            </div>
                            <div class="col-sm-12 name">
                                <div class="form-group">
                                    <label>About</label>
                                    <input #jobRole class="c-form-control jobRole" placeholder="Job Role" formControlName="jobRole" value="{{userDetails.description}}" maxlength="41"
                                        autocomplete="off" (keyup)="jobRoleChanges = true" />

                                </div>
                            </div>
                        </form>
                        <!-- <div class="col-sm-6">
                        <div class="form-group">
                            <input class="form-control va-title" placeholder="Designation" value="Designation" autocomplete="off"/> -->
                        <!-- <input class="form-control va-title" placeholder="Ask CIRA" [(ngModel)]="user.name" />                             -->
                        <!-- </div>
                    </div>  -->
                        <h5>Change Password</h5>
                        <form [formGroup]="passwordForm" class="set-password">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <input #previousPassword appRestrictCutcopypaste type="{{prevPasswordShow?'text':'password'}}" (focus)="edit = true" (blur)="edit = false" formControlName="previousPassword" class="c-form-control va-title" id="prePasswordInput" placeholder="Current Password"
                                        autocomplete="off" />
                                    <!-- <input class="form-control va-title" placeholder="Ask CIRA" [(ngModel)]="user.name" />                             -->
                                    <a class="passsword-visible c-form-control-icon" [ngClass]="{'disabled':!edit}" [class.text]="prevPasswordShow" (click)="prevPasswordShow = !prevPasswordShow"><i class="icon"></i></a>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group" [ngClass]="{'error': passwordForm.controls.password.touched && !passwordForm.controls.password.valid}">
                                    <input #password appRestrictCutcopypaste type="{{passwordShow?'text':'password'}}" formControlName="password" validatePassword="password" class="c-form-control va-title" id="passwordInput" placeholder="New Password" autocomplete="off" />
                                    <!-- <input class="form-control va-title" placeholder="Ask CIRA" [(ngModel)]="user.name" />                             -->
                                    <a class="passsword-visible c-form-control-icon" [class.text]="passwordShow" (click)="passwordShow = !passwordShow"><i class="icon"></i></a>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group" [ngClass]="{'error': passwordForm.controls.confirmPassword.touched && !passwordForm.controls.confirmPassword.valid}">
                                    <input #confirmPassword appRestrictCutcopypaste type="{{confirmPasswordShow?'text':'password'}}" formControlName="confirmPassword" validatePassword="confirmPassword" class="c-form-control va-title" id="confirmPasswordInput" placeholder="Confirm Password"
                                        autocomplete="off" />
                                    <!-- <input class="form-control va-title" placeholder="Ask CIRA" [(ngModel)]="user.name" />                             -->
                                    <a class="passsword-visible c-form-control-icon" [class.text]="confirmPasswordShow" (click)="confirmPasswordShow = !confirmPasswordShow"><i class="icon"></i></a>
                                    <i #passwordInfo="ngbTooltip" class="icon-information" placement="right" ngbTooltip="Password should have minimum 8 and maximum 50 letters, should have atleast one uppercase, one lowercase ,one  symbol and one number"></i>
                                </div>
                            </div>
                            <span class="form-error" *ngIf="!passwordValidationStatus">{{validPasswordmessage}}</span>
                            <span class="form-error" *ngIf="!previousPasswordmatch && passwordNotMatch && passwordValidationStatus "> New password should not be same as current password</span>
                            <span class="form-error" *ngIf="!passwordNotMatch && passwordValidationStatus ">Passwords are not matching</span>
                        </form>
                        <div class="col-sm-12 mfa-control-wrap">
                            <label for="mfa-slider">Multi Factor Authentication(Recommended)</label>
                            <div class="btn-switch" id="mfa-slider">
                                <label class="el-switch el-switch-green mr-1">
                                    <input type="checkbox" name="mfa" [(ngModel)]="mfaStatus" (change)="mfaChangeHandler()">
                                    <i  *ngIf = "!mfaStatus"   class="icon-warn icon-topic-warnning"> <span class="warn-bg"></span></i>
                                   
                                    <span class="el-switch-style">
                                        <strong class="text-one" >OFF</strong>
                                        <!-- <i class="icon-topic-warnning"></i> -->
                                        
                                        <strong class="text-two">ON</strong>
                                    </span>
                                </label>
                            </div>
                        </div>
                        <button type="submit" class="save btn btn-green" (click)="updateDetails()" [disabled]="!((passwordForm.touched && passwordForm.valid) || mfaChanged || firstNameChanged || lastNameChanged || jobRoleChanges)">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>

<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Upload a profile picture</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click');closeCrop();">
            <span aria-hidden="true">&times;</span>
            </button>
    </div>
    <div class="modal-body">
        <div class="profile-pic-uploader">
            <ul>
                <li>Please upload profile picture image files in format such as .png, .jpg, .jpeg.</li>
                <li>Image file should be less than 10 Mb.</li>
            </ul>

            <form [formGroup]="imageForm">
                <div class="upload-img">
                    <button class="fileUpload btn">
                            Upload
                        </button>

                    <span class="file-name">
                            <input class="upload upload-image" formControlName="imageUpload"  type="file" accept=".png, .jpg, .jpeg" (change)="fileChangeEvent($event)" (imageLoaded)="imageLoaded()" />
                        </span>
                </div>
                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="1/1" [resizeToWidth]="128" format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (loadImageFailed)="loadImageFailed()"></image-cropper>

                <p class="text-center">Current Profile Picture</p>
                <div class="img-defualt">
                    <img [src]="croppedImage" />
                </div>

                <!-- <img-cropper [image]="data" [settings]="cropperSettings"></img-cropper><br>
                            <img #profileImg [src]="data.image" [width]="cropperSettings.croppedWidth" [height]="cropperSettings.croppedHeight"> -->
                <div class="upload-img-btn">
                    <button class="save btn btn-green crop-btn" [disabled]="!imageloaded" (click)="d('Cross click'); imgSave(croppedImage,'update');">Crop and Save</button>
                    <button class="btn btn-remove" [disabled]="!defaultpic" (click)="imgRemove(content);">Remove <i class="icon-delete-garbage-streamline"></i></button>
                </div>
                <div class="error" *ngIf="fileError">{{fileErrorText}}</div>
            </form>

        </div>
    </div>
</ng-template>